export const PricesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="-1 -1 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 18.4V1.6C1 1.26863 1.26863 1 1.6 1H18.4C18.7314 1 19 1.26863 19 1.6V18.4C19 18.7314 18.7314 19 18.4 19H1.6C1.26863 19 1 18.7314 1 18.4Z"
      stroke="#444444"
      strokeWidth="1.5"
    />
    <path
      d="M13 6.5C12.315 5.81501 11.1087 5.33855 10 5.30872M10 5.30872C8.6809 5.27322 7.5 5.86998 7.5 7.50001C7.5 10.5 13 9 13 12C13 13.711 11.5362 14.4462 10 14.391M10 5.30872V3.5M7 13C7.64448 13.8593 8.8428 14.3494 10 14.391M10 14.391V16.5"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
